<ng-template #modalTemplate>
   <div class="modal-header">
      <h4 class="modal-title pull-left">{{ 'Restrictions' | translate }}</h4>
   </div>
   <div class="modal-body">
      <div
         *ngFor="let restriction of restrictions; let i = index"
         [attr.data-index]="i"
         class="restriction-row row"
      >
         <p class="spacing"
            ><b> {{ i + 1 }}. </b></p
         >
         <p *ngIf="restriction.id">
            <b>{{ 'Id' | translate }}:</b> {{ restriction.id }}
         </p>
         <p *ngIf="restriction.productName">
            <b>{{ 'Product name' | translate }}:</b> {{ restriction.productName }}
         </p>
         <p *ngIf="restriction.productCode">
            <b>{{ 'Product code' | translate }}:</b> {{ restriction.productCode }}
         </p>
         <p *ngIf="restriction.batchNumber">
            <b>{{ 'Batch number' | translate }}:</b> {{ restriction.batchNumber }}
         </p>
         <p *ngIf="restriction.serialNumber">
            <b>{{ 'Serial number' | translate }}:</b> {{ restriction.serialNumber }}
         </p>
         <p *ngIf="restriction.quantity">
            <b>{{ 'Quantity' | translate }}:</b> {{ restriction.quantity }}
         </p>
      </div>
   </div>
   <div class="modal-footer">
      <button class="btn btn-primary" (click)="close()">{{ 'Close' | translate }}</button>
   </div>
</ng-template>
